import serialNumberSelectionModel from './serialNumberSelectionModel.vue'
export default serialNumberSelectionModel
